/* global __webpack_public_path__:writable */

__webpack_public_path__ = document.currentScript.src + '/../';
